module.exports = __webpack_public_path__ + "img/icon-1.fb0d76c4.png";